export class HQStepIds {
  public static readonly GetStarted = 'GetStarted'.toLowerCase();
  public static readonly StartYourQuote = 'StartYourQuote'.toLowerCase();
  public static readonly CoverDetails = 'CoverDetails'.toLowerCase();
  public static readonly BuildingDetails = 'BuildingDetails'.toLowerCase();
  public static readonly PortableItems = 'PortableItems'.toLowerCase();
  public static readonly HomeItems = 'HomeItems'.toLowerCase();
  public static readonly GeneralContents = 'GeneralContents'.toLowerCase();
  public static readonly PersonalDetails = 'PersonalDetails'.toLowerCase();
  public static readonly YourQuote = 'YourQuote'.toLowerCase();
}

export class APIValues {
  static readonly BuildingType = class {
    public static readonly House = 'House';
    public static readonly Duplex = 'Duplex';
    public static readonly Townhouse = 'Townhouse';
    public static readonly Unit = 'Unit';
    public static readonly Flat = 'Flat';
    public static readonly BoardingHome = 'BoardingHome';
    public static readonly ManufTransportableHome = 'ManufTransportableHome';
    public static readonly Storage = 'Storage';
  };
  static readonly OccupancyType = class {
    public static readonly OwnerOccupied = 'OWNEROCC';
    public static readonly Landlord = 'LANDLORD';
  };
  static readonly PolicyType = class {
    public static readonly HomeOnly = 'HH';
    public static readonly ContentOnly = 'HC';
    public static readonly HomeAndContents = 'HHCOMB';
  };
  static readonly PropertyFeatures = class {
    public static readonly GarageRollerDoors = 'GRD';
    public static readonly WindowWeatherProtection = 'WWP';
    public static readonly UpgradedReplacedRoof = 'URR';
  };
}
